export default "__VITE_ASSET__7924c8a7__"